<script>

	import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

	import './style.scss'

	import {
		URL_PREFIX
	} from '@/constants.js'

	export default {
		name: 'loginbox',
		components: {
			ClipLoader
		},
		data: () => ({
			loading: false,
			email: '',
			password: '',
			color: '#fff',
			URL_PREFIX
		}),
		methods: {
			login() {
				this.loading = true
				this.$store.dispatch('login', {
					email: this.email,
					password: this.password
				}).then(loginStatus => {
					this.loading = false
					if (!!loginStatus) this.$router.push('/')
					else {
						this.$store.dispatch('notification', {
							show: true,
							type: 'error',
							message: 'Email or password is incorrect.',
							duration: 5000,
						})
					}
				});
			}
		},
	}

</script>

<template>
	<div class='loginbox'>
		<a href='/'>
			<img class='mobile' src='/static/logo-head-white.svg'>
		</a>
		<div class='loginbox-container'>
			<header>
				Sign In
			</header>
			<form @submit.prevent='login({ email, password })' class='form-container'>
				<input
					v-model='email'
					type='email'
					name='email'
					placeholder='Email address'
					required
					:disabled='loading === true'
					autocomplete='new-password'
				/>
				<input
					v-model='password'
					type='password'
					name='password'
					placeholder='Password'
					required
					:disabled='loading === true'
					autocomplete='new-password'
				/>
				<button
					:disabled='loading === true'
					type='submit'
					:class='{ submit: true, loading, login }'

				>
					<span v-if='loading === false'>
						Login&nbsp;&nbsp;&nbsp;⟶
					</span>
					<span v-if='loading === true'>
						Signing In...&nbsp;&nbsp;&nbsp;
					</span>
				</button>

			</form>
		</div>
		<p class='account-tos'>
			Don't have an account?
			<a :href='`${URL_PREFIX}/register`'>Sign Up</a>.
		</p>
	</div>
</template>



// WEBPACK FOOTER //
// src/components/LoginBox/LoginBox.vue